function LogoutIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#7953D2" fillOpacity="0.2" />
      <path
        d="M16.6667 18C17.0333 18 17.3471 17.8696 17.608 17.6087C17.8689 17.3478 17.9996 17.0338 18 16.6667V7.33333C18 6.96667 17.8693 6.65289 17.608 6.392C17.3467 6.13111 17.0329 6.00044 16.6667 6H12.6667C12.4778 6 12.3193 6.064 12.1913 6.192C12.0633 6.32 11.9996 6.47822 12 6.66667C12.0004 6.85511 12.0644 7.01356 12.192 7.142C12.3196 7.27044 12.4778 7.33422 12.6667 7.33333H16.6667V16.6667H12.6667C12.4778 16.6667 12.3193 16.7307 12.1913 16.8587C12.0633 16.9867 11.9996 17.1449 12 17.3333C12.0004 17.5218 12.0644 17.6802 12.192 17.8087C12.3196 17.9371 12.4778 18.0009 12.6667 18H16.6667ZM8.55 12.6667H13.3333C13.5222 12.6667 13.6804 12.6027 13.808 12.4747C13.9356 12.3467 13.9996 12.1884 14 12C14.0004 11.8116 13.9364 11.6533 13.808 11.5253C13.6796 11.3973 13.5213 11.3333 13.3333 11.3333H8.55L9.8 10.0833C9.92222 9.96111 9.98333 9.81111 9.98333 9.63333C9.98333 9.45556 9.92222 9.3 9.8 9.16667C9.67778 9.03333 9.52222 8.96378 9.33333 8.958C9.14444 8.95222 8.98333 9.01622 8.85 9.15L6.46667 11.5333C6.33333 11.6667 6.26667 11.8222 6.26667 12C6.26667 12.1778 6.33333 12.3333 6.46667 12.4667L8.85 14.85C8.98333 14.9833 9.14155 15.0473 9.32467 15.042C9.50778 15.0367 9.66622 14.9671 9.8 14.8333C9.92222 14.7 9.98044 14.5418 9.97467 14.3587C9.96889 14.1756 9.90511 14.0227 9.78333 13.9L8.55 12.6667Z"
        fill="#492897"
      />
    </svg>
  );
}

export default LogoutIcon;
